export default "__VITE_ASSET__etltkzsg__"